import {IFileDesc} from './file.types';

export interface IEvent {
    id:number;
    groupId?:number;
    title:string;
    description?:string;
    hasTime:boolean;
    startTime:number;
    endTime:number;
    privacy:PRIVACY;
    visible?:number[];
    tagged?:number[];
    notification?:number[];
    customNotification?:IEventNotification[];
    seen?:number[];
    creator:number;
    checkmark:boolean|undefined;
    completedBy:number|undefined;
    file?:IFileDesc;
    eventType?:EVENT_TYPE;
}

export interface IEventNotification {
    accountId:number;
    timeDelta:number;
}

export interface ILocalEvent {
    id:string;
    title:string;
    description?:string;
    startTime:number;
    endTime:number;
    hasTime:boolean;
    calendar:string
}

export enum PRIVACY  {
    PRIVATE = "PRIVATE",
    ADULTS = "ADULTS",
    ALL = "ALL",
}
 
export enum EVENT_TYPE  {
    NORMAL = "NORMAL",
    SCHOOL_HOLIDAY = "SCHOOL_HOLIDAY",
    AI = "AI",
    UNKNOWN = "UNKNOWN",
}

export enum REPEATABLE  {
    ONCE = "ONCE",
    WEEKLY = "WEEKLY",
    BI_WEEKLY = "BI_WEEKLY",
    MONTHLY = "MONTHLY",
    FOUR_WEEKS = "FOUR_WEEKS",
    YEARLY = "YEARLY",
}

export interface IDeleteEvent {
    id?:number;
    groupId?:number;
    /** With groupId: delete event `id` and the group's later events, keeping earlier ones. */
    thisAndFollowing?:boolean;
}

export interface IEditEventVisibility {
    viewerUserId: number;
    events: number[]
}

export interface IEditEvent {
    id:number;
    groupId?:number;
    modifyGroup:boolean;
    title:string;
    description?:string;
    hasTime:boolean;
    startTime:number;
    endTime:number;
    privacy:PRIVACY;
    visible:number[];
    tagged:number[];
    notification:number[];
    customNotification?:IEventNotification[];
    checkmark:boolean;
    completedBy:number|undefined;
    fileId?:number;
}

export interface ICreateNewEvent {
    title:string;
    description?:string;
    hasTime:boolean;
    startTime:number;
    endTime:number;
    visible:number[];
    tagged:number[];
    notification:number[];
    privacy:PRIVACY;
    occurences:number;
    frequency:REPEATABLE;
    eventType?:EVENT_TYPE;
    customNotification?:IEventNotification[];
    checkmark:boolean;
    completedBy:number|undefined;
    fileId?:number;
}


export interface IAiTask {
    id?:number;
	status?:AI_RESULT;
    errorMsg?:string;
    dismissed?:boolean;
    startTime?:number;
    taskType?:AI_TASK_TYPE;
	
	promptOne?:string;
	promptTwo?:string;
	promptThree?:string;

    result?:string;
    refObject?:number;
    doNotClearPreviousSchoolImport?:boolean;
    accountIds?:number[];

	language?:"SE"|"EN";
}

export interface IAnalysedImage {
    id:number;
	fileId?:number;
    url?:string;
	result:AI_RESULT;
	events?:IAnalysedEvent[];
    errorMsg?:string;
    dismissed?:boolean;
    startTime?:number;
    taskType?:AI_ANALYZE_TASK_TYPE;
    receipts?:IAnalysedReceipt[];
    text?:string; // data to analyse
    markdown?:string; // the structured data from ai
}

export enum AI_ANALYZE_TASK_TYPE  {
    UNKNOWN = "UNKNOWN",
    EVENT = "EVENT",
    RECEIPT = "RECEIPT",
    TEXT = "TEXT",
    STRUCTURED = "STRUCTURED",
}

export enum AI_TASK_TYPE  {
    UNKNOWN = "UNKNOWN",
    SCHOOL_VACATIONS = "SCHOOL_VACATIONS",
    SCHEDULE_ALTERATION = "SCHEDULE_ALTERATION",
    NOTE = "NOTE",
    NOTE_ICON = "NOTE_ICON",
    CHAT_ICON = "CHAT_ICON",
    MESSAGE_POLISH = "MESSAGE_POLISH",
}

export enum AI_RESULT  {
    UNKNOWN = "UNKNOWN",
    IN_PROGRESS = "IN_PROGRESS",
    SUCCESS = "SUCCESS",
    NO_DATA = "NO_DATA", // tech success but could not parse useful data out of image
    FAIL = "FAIL", // failed to analyse image
}

export interface IAnalysedEvent {
    id:string;
    title?:string;
    description?:string;
    startDate?:string;
    endDate?:string;
    startTime?:string;
    endTime?:string;
    checkmark?:boolean;
    imageUrl?:string;
    fileUrl?:string;
    fileId?:number;
    forAccountIds?:number[];
}

// Backend AiAnalysedData.AiReceipt has no @JsonInclude(NON_NULL), so any field can arrive as null.
export interface IAnalysedReceipt {
    id?:string|null;
    title?:string|null;
    description?:string|null;
    currency?:string|null;
    amount?:string|null;
    imageUrl?:string|null;
    fileId?:number|null;
}



// WEBPACK FOOTER //
// ./src/app-types/websocket/event.types.ts